export function capitalizeFirst(input: string | null | undefined): string | null {
  if (input === null || input === undefined) return null;
  return String(input.charAt(0).toUpperCase() + input.slice(1));
}
